import AntDrawer, { DrawerProps } from 'antd/lib/drawer';
import styled from 'styled-components';
import { ModalsZIndex } from 'src/components/constants';
import { useOverlayStackDepth } from 'src/components/providers/overlay-stack-depth-provider';

const LggDrawerComponent = styled(AntDrawer)`
  .ant-drawer-body {
    padding: 0;
  }
`;

export const LggDrawer = (props: DrawerProps & { children?: React.ReactNode }) => {
  const stackDepth = useOverlayStackDepth(props.visible ?? false);

  return (
    <LggDrawerComponent {...props} zIndex={ModalsZIndex + (stackDepth ?? 0)}>
      {props.children}
    </LggDrawerComponent>
  );
};
